import ProductPage from './ProductPage';

const features = [
  { heading: 'Built for your business', text: 'A full-featured web dashboard that handles PF, ESI, professional tax and salary structures out of the box.', icon: '🖥' },
  { heading: 'Save time every day', text: 'Run bulk online payouts, generate payslips and export reports in minutes instead of days.', icon: '⏱' },
  { heading: 'Secure and reliable', text: 'Real-time dashboards across branches with role-based access for HR, finance and management.', icon: '🔒' },
];

export default function Desktop() {
  return (
    <ProductPage
      title="Desktop"
      subtitle="Easy payroll management with PF/ESI, bulk payments, intelligent dashboards and much more."
      features={features}
      ctaTitle="Desktop"
    />
  );
}
